import { api } from "../../App";
import { createNotification } from "../../components/Notifications/Notifications";
import { SET_STUDENTS_LOADING } from "../types";

// GET /students/{mid}/photo — фото учащегося (blob), 404 если отсутствует
export const getStudentPhoto = (mid) => async () => {
  try {
    const response = await api.get(`/students/${mid}/photo`, { responseType: 'blob' });
    return response.data;
  } catch (ERR) {
    return null;
  }
};

// POST /students/{mid}/photo — загрузка/замена фото (FormData, поле 'photo')
export const uploadStudentPhoto = (mid, file) => async (dispatch) => {
  let success = false;
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    const formData = new FormData();
    formData.append('photo', file);
    await api.post(`/students/${mid}/photo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    success = true;
    createNotification('success', 'Фото успешно загружено');
  } catch (ERR) {
    console.error('uploadStudentPhoto error:', ERR);
    createNotification('error', ERR?.response?.data?.detail || 'Ошибка загрузки фото');
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
    return success;
  }
};

// DELETE /students/{mid}/photo — удаление фото
export const deleteStudentPhoto = (mid) => async (dispatch) => {
  let success = false;
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    await api.delete(`/students/${mid}/photo`);
    success = true;
    createNotification('success', 'Фото успешно удалено');
  } catch (ERR) {
    console.error('deleteStudentPhoto error:', ERR);
    createNotification('error', ERR?.response?.data?.detail || 'Ошибка удаления фото');
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
    return success;
  }
};
